<script lang="ts">
import AppLayout from "@/Layouts/App.vue";
import BreezeValidationErrors from "@/Components/ValidationErrors.vue";
import RegisterForm from "@/Pages/Auth/RegisterForm.vue";
import { defineComponent } from "vue";
import MainPage from "@/Components/MainPage.vue";
import Plane from "@/Components/Generics/Plane.vue";
import GenericButton from "@/Components/Generics/GenericButton.vue";

export default defineComponent({
    name: "RegisterVue",
    components: {
        MainPage,
        Plane,
        GenericButton,
        BreezeValidationErrors,
        RegisterForm,
    },
    layout: AppLayout,
    props: {},
    data() {
        return {
            formCompany: this.$inertia.form({
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                terms: false,
                type: "company",
            }),

            formSchool: this.$inertia.form({
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                terms: false,
                type: "school",
            }),

            selectedForm: null as "school" | "company",
        };
    },

    methods: {
        submitCompany() {
            this.formCompany.post(this.route("register"), {
                onFinish: () => this.formCompany.reset("password", "password_confirmation"),
            });
        },
        submitSchool() {
            this.formSchool.post(this.route("register"), {
                onFinish: () => this.formSchool.reset("password", "password_confirmation"),
            });
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('auth.register')">
        <div class="register-wrapper register-wrapper--desktop flex flex--h flex--width flex--halign-c flex--gap-50">
            <Plane :darker="true">
                <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                    <span class="text text--size-20 text--primary-b text--semi-bold text--center">{{ $trans("auth.register_company") }}</span>
                    <BreezeValidationErrors class="mb-4" />

                    <RegisterForm :form="formCompany" @submit.prevent="submitCompany" />
                </div>
            </Plane>

            <Plane :darker="true">
                <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                    <span class="text text--size-20 text--primary-b text--semi-bold text--center">{{ $trans("auth.register_school") }}</span>
                    <BreezeValidationErrors class="mb-4" />

                    <RegisterForm :form="formSchool" @submit.prevent="submitSchool" />
                </div>
            </Plane>
        </div>

        <div class="register-wrapper register-wrapper--mobile flex flex--v flex--width flex--valign-c flex--gap-50">
            <div class="register-wrapper-choose flex flex--v flex--valign-c flex--gap-30" :class="{ 'register-wrapper-choose--margin': !selectedForm }">
                <GenericButton v-if="!selectedForm" :title="$trans('auth.register_company')" :secondary="true" @click="selectedForm = 'company'" />
                <GenericButton v-if="!selectedForm" :title="$trans('auth.register_school')" :secondary="true" @click="selectedForm = 'school'" />

                <GenericButton v-if="selectedForm" :title="$trans('main.button_back')" :identifier="'arrow_left'" @click="selectedForm = null" />
            </div>

            <Plane v-if="selectedForm === 'company'" :darker="true">
                <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                    <span class="text text--size-20 text--primary-b text--semi-bold text--center">{{ $trans("auth.register_company") }}</span>
                    <BreezeValidationErrors class="mb-4" />

                    <RegisterForm :form="formCompany" @submit.prevent="submitCompany" />
                </div>
            </Plane>

            <Plane v-if="selectedForm === 'school'" :darker="true">
                <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                    <span class="text text--size-20 text--primary-b text--semi-bold text--center">{{ $trans("auth.register_school") }}</span>
                    <BreezeValidationErrors class="mb-4" />

                    <RegisterForm :form="formSchool" @submit.prevent="submitSchool" />
                </div>
            </Plane>
        </div>
    </MainPage>
</template>

<style lang="scss" scoped>
.register-wrapper {
    &.register-wrapper--desktop {
        display: flex;
    }

    &.register-wrapper--mobile {
        display: none;

        .register-wrapper-choose {
            &.register-wrapper-choose--margin {
                margin-top: rem(100);
            }
        }
    }
}

@include media-breakpoint-down(lg) {
    .register-wrapper {
        flex-direction: column;

        &.register-wrapper--desktop {
            display: none;
        }

        &.register-wrapper--mobile {
            display: flex;
        }
    }
}
@include media-breakpoint-down(md) {
}
</style>
